import React, { useState } from 'react';
import { Table, Button, Row, Col, Image } from 'react-bootstrap';
import { FaEdit, FaTrash } from 'react-icons/fa';
import { useParams, useNavigate } from 'react-router-dom';
import Message from '../../components/Message';
import Loader from '../../components/Loader';
import Paginate from '../../components/Paginate';
import {
  useGetProductsQuery,
  useCreateProductMutation,
  useDeleteProductMutation,
} from '../../slices/productsApiSlice';
import { toast } from 'react-toastify';
import moment from 'moment';
import { getImageUrl } from '../../utils/imageUtils'; // ✅ Import de l'utilitaire

const ProductListScreen = () => {
  const { pageNumber } = useParams();
  const navigate = useNavigate();

  const { data, isLoading, error, refetch } = useGetProductsQuery({
    pageNumber,
    sortBy: 'position_asc',
  });

  const [createProduct, { isLoading: loadingCreate }] =
    useCreateProductMutation();
  const [deleteProduct, { isLoading: loadingDelete }] =
    useDeleteProductMutation();

  const [imageErrors, setImageErrors] = useState({});

  // ✅ Utilisation de l'utilitaire pour obtenir l'URL complète
  const handleImageError = (productId) => {
    setImageErrors(prev => ({
      ...prev,
      [productId]: true
    }));
  };

  const createProductHandler = async () => {
    if (window.confirm('Are you sure you want to create a product?')) {
      try {
        await createProduct();
        toast.success('Product created');
        refetch();
      } catch (err) {
        toast.error(err?.data?.message || err.error);
      }
    }
  };

  const deleteHandler = async (id) => {
    if (window.confirm('Are you sure?')) {
      try {
        await deleteProduct(id);
        toast.success('Product deleted');
        refetch();
      } catch (err) {
        toast.error(err?.data?.message || err.error);
      }
    }
  };

  const editProductHandler = (id) => {
    const editPath = `/admin/product/${id}/edit`;
    navigate(editPath);
  };

  return (
    <>
      <Row className='align-items-center'>
        <Col>
          <h1>Products</h1>
        </Col>
        <Col className='text-end'>
          <Button className='btn-sm m-3' onClick={createProductHandler}>
            <FaEdit /> Create a product
          </Button>
        </Col>
      </Row>

      {loadingCreate && <Loader />}
      {loadingDelete && <Loader />}
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant='danger'>{error}</Message>
      ) : (
        <>
          <Table striped bordered hover responsive className='table-sm'>
            <thead>
              <tr>
                <th>Image</th>
                <th>Position</th>
                <th>Name</th>
                <th>Type</th>
                <th>Proprietaire</th>
                <th>TND</th>
                <th>EUR</th>
                <th>USD</th>
                <th>Date</th>
                <th>Category</th>
                <th>Brand</th>
                <th>Stock</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {data.products.map((product) => (
                <tr key={product._id}>
                  {/* ✅ COLONNE IMAGE avec gestion d'environnement */}
                  <td>
                    <Image 
                      src={imageErrors[product._id] ? '/images/placeholder.jpg' : getImageUrl(product.image)} 
                      alt={product.name}
                      style={{ width: '50px', height: '50px', objectFit: 'cover' }}
                      onError={() => handleImageError(product._id)}
                    />
                  </td>
                  <td>{product.position}</td>
                  <td>{product.name}</td>
                  <td>{product.type}</td>
                  <td>{product.proprio}</td>
                  <td>{product.price}</td>
                  <td>{product.priceEur}</td>
                  <td>{product.priceDol}</td>
                  <td>{moment(product.date).format('DD MMMM YYYY')}</td>
                  <td>{product.category}</td>
                  <td>{product.brand}</td>
                  <td>{product.countInStock}</td>
                  <td>
                    <Button
                      variant='light'
                      className='btn-sm mx-2'
                      onClick={() => editProductHandler(product._id)}
                    >
                      <FaEdit />
                    </Button>
                    <Button
                      variant='danger'
                      className='btn-sm'
                      onClick={() => deleteHandler(product._id)}
                    >
                      <FaTrash style={{ color: 'white' }} />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          <Paginate
            pages={data.pages}
            page={data.page}
          />
        </>
      )}
    </>
  );
};

export default ProductListScreen;